import React from "react";

const BannerMessage = ({ message }) => {
  return (
    <div className="banner banner-below-migration">
      <div className="banner-inner text-center">
        <p className="bannerText">{message}</p>
      </div>
    </div>
  );
};

export default BannerMessage;
